export function Button({
  type = "button",
  className = "",
  variant,
  children,
  ...rest
}) {
  const base =
    variant === "accent" ? "button button--accent" : "button";
  return (
    <button
      type={type}
      className={`${base} ${className}`.trim()}
      {...rest}
    >
      {children}
    </button>
  );
}
